import React from "react";
import { places, icons } from "../data/data";
import styled from "styled-components";
import Rs from "../../utils/images/rsvp-1920.jpg";
const Layout = styled.div`
  font-family: "Oswald" sans-serif;
  .container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    justify-content: center;
    padding: 20px 10%;
    @media (width: 768px) {
      grid-template-columns: repeat(2, 1fr);
      justify-content: center;
    }
    @media (max-width: 767px) {
      grid-template-columns: 1fr;
      justify-content: center;
      padding: 20px 5%;
    }
  }
  .circle {
    color: #f039ad;
    font-size: 35px;
  }
`;

function Places() {
  return (
    <>
      <Layout>
        <h3 style={styles.title}> INTEREST PLACE AROUND</h3>
        <div className="container">
          {places &&
            places.map((place, index) => {
              const Icon = icons[index];
              return (
                <div style={styles.wrapper} key={place.id}>
                  <span className="circle">
                    <Icon />
                  </span>
                  <div style={styles.contain}>
                    <h3> {place.title}</h3>
                    <p style={styles.desc}>{place.desc}</p>
                  </div>
                </div>
              );
            })}
        </div>
        \
      </Layout>
    </>
  );
}
const styles = {
  pixCon: {
    background: `url(${Rs})`,
    height: 300,
    backgroundSize: "cover",
    display: "flex",
    alignItems: "flex-end",
    color: "white",
    textTransform: "uppercase",
  },
  title: {
    fontSize: 23,
    fontWeight: 500,
    marginTop: 80,
    marginBottom: 50,
    textAlign: "center",
  },
  wrapper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: 325,
    height: 125,
    margin: 18,
  },

  desc: {
    fontSize: 14,
    color: "#6a6a6a",
    fontWeight: 400,
    fontFamily: "san-serif",
    margin: "  0px 0px 25px",
    lineHeight: "20px",
  },
  contain: {
    marginTop: 15,
    marginLeft: 15,
  },
};

export default Places;
